/**
 * Resolve active club id from userInfo (array or single user object).
 * @param {Array|object|null|undefined} userInfo
 * @returns {number|null}
 */
export function resolveClubId(userInfo) {
  const u = Array.isArray(userInfo) ? userInfo[0] : userInfo;
  if (!u) return null;
  const raw = u.clubID ?? u.clubId;
  if (raw == null || raw === "") return null;
  const n = typeof raw === "number" ? raw : parseInt(String(raw), 10);
  return Number.isNaN(n) || n <= 0 ? null : n;
}

/**
 * Query params for multi-club context (?clubID=).
 * Backend enforceClubID allows any membership in that club and binds roles to it.
 * @param {number|string|null|undefined} clubID
 */
export function clubQueryParams(clubID) {
  if (clubID == null || clubID === "") return {};
  const n = typeof clubID === "number" ? clubID : parseInt(String(clubID), 10);
  if (Number.isNaN(n) || n <= 0) return {};
  return { clubID: n };
}

export function mergeClubQueryParams(params = {}, clubID = null) {
  return { ...params, ...clubQueryParams(clubID) };
}

/** Per-club localStorage key for finance billing period selection. */
export function financePeriodStorageKey(clubID, baseKey) {
  const id = clubID != null ? clubID : null;
  if (id == null) return baseKey;
  return `${baseKey}:${id}`;
}
